var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarImageStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 338,
    viewBox: "0 0 340 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00027 144.37C14.2158 84.0684 51.9997 9.98344 126.646 2.23036C126.646 2.23036 183.321 -4.66115 239.189 5.78365C272.348 11.9826 301.423 30.4356 319.82 56.9571C338.218 83.4787 344.363 115.818 336.905 146.65C332.061 166.675 328.787 187.401 329.686 207.978C331.249 243.791 330.35 277.22 295.584 298.577C264.541 317.648 225.474 334.467 188.204 337.413C162.875 339.415 134.47 336.175 110.058 329.583C-14.3524 295.986 -4.2153 204.672 5.00027 144.37Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.805 173.078C219.339 134.85 185.078 22.26 255.346 29.2489C302.632 33.9519 270.894 72.4304 301.118 84.8461C331.341 97.2617 335.684 133.8 295.515 180.831C255.346 227.861 203.435 245.493 203.435 245.493C203.435 245.493 236.27 211.306 227.805 173.078Z",
    fill: "url(#paint0_linear_18300_185650)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18300_185650",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 203,
    y: 29,
    width: 122,
    height: 217
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.801 173.079C219.335 134.851 184.909 24.1936 255.342 29.2497C300.698 32.5057 270.89 72.4313 301.114 84.847C331.338 97.2626 335.68 133.801 295.511 180.831C255.342 227.862 203.431 245.494 203.431 245.494C203.431 245.494 236.266 211.306 227.801 173.079Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18300_185650)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.288 249.856C196.372 249.856 196.455 249.836 196.53 249.798C273.456 211.347 263.027 130.968 256.795 82.9433C256.063 77.2964 255.371 71.9628 254.907 67.3049C252.689 45.0417 257.282 33.5582 261.525 27.8451C266.088 21.7031 271.233 20.7504 271.285 20.7415C271.426 20.7171 271.552 20.6376 271.636 20.5203C271.719 20.403 271.752 20.2576 271.728 20.1159C271.704 19.9742 271.624 19.8479 271.507 19.7646C271.39 19.6812 271.245 19.6478 271.103 19.6715C270.878 19.7094 265.541 20.6736 260.717 27.1133C256.326 32.9751 251.566 44.7247 253.826 67.4125C254.292 72.0863 254.985 77.4278 255.719 83.0829C261.913 130.822 272.28 210.722 196.045 248.827C195.935 248.882 195.848 248.972 195.796 249.083C195.744 249.194 195.731 249.319 195.759 249.438C195.787 249.557 195.855 249.663 195.951 249.739C196.047 249.814 196.166 249.856 196.288 249.856Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.338 110.44C259.429 110.441 259.519 110.418 259.598 110.374C259.678 110.33 259.746 110.267 259.795 110.19C259.856 110.096 265.966 100.628 275.62 91.9509C284.482 83.9858 298.237 75.071 313.433 77.8336C313.575 77.8593 313.721 77.8278 313.839 77.7459C313.958 77.664 314.039 77.5384 314.064 77.3968C314.09 77.2552 314.059 77.1092 313.977 76.9908C313.895 76.8725 313.769 76.7915 313.628 76.7657C301.25 74.5155 287.849 79.4935 274.876 91.1604C265.118 99.9358 258.942 109.51 258.881 109.605C258.828 109.687 258.799 109.782 258.796 109.879C258.792 109.976 258.815 110.073 258.862 110.158C258.909 110.243 258.977 110.315 259.061 110.364C259.145 110.414 259.24 110.44 259.338 110.44Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.32 164.772C258.399 164.772 258.477 164.755 258.548 164.722C258.62 164.689 258.683 164.641 258.734 164.581C258.818 164.482 267.267 154.615 280.21 145.88C292.115 137.846 310.372 129.15 329.748 133.345C329.817 133.36 329.889 133.361 329.959 133.349C330.029 133.336 330.096 133.31 330.156 133.271C330.216 133.232 330.268 133.182 330.309 133.124C330.349 133.065 330.378 132.999 330.393 132.93C330.408 132.86 330.409 132.788 330.397 132.718C330.384 132.648 330.357 132.581 330.319 132.521C330.28 132.461 330.23 132.409 330.172 132.369C330.113 132.328 330.047 132.299 329.977 132.284C310.218 128.006 291.665 136.836 279.58 144.996C266.52 153.815 257.991 163.778 257.907 163.878C257.839 163.957 257.796 164.053 257.782 164.156C257.768 164.259 257.784 164.363 257.828 164.457C257.871 164.551 257.941 164.631 258.028 164.686C258.115 164.742 258.217 164.772 258.32 164.772Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M256.354 83.3072C256.451 83.3072 256.547 83.2809 256.631 83.2312C256.714 83.1816 256.783 83.1103 256.83 83.0249C256.877 82.9395 256.9 82.8432 256.896 82.7459C256.893 82.6487 256.863 82.5541 256.811 82.4721C256.75 82.3764 250.574 72.8027 240.816 64.0273C227.842 52.3603 214.443 47.3834 202.064 49.6326C201.923 49.6584 201.797 49.7393 201.715 49.8577C201.633 49.976 201.602 50.122 201.627 50.2636C201.653 50.4052 201.734 50.5308 201.852 50.6127C201.971 50.6946 202.117 50.7262 202.259 50.7004C217.455 47.9373 231.21 56.8527 240.071 64.8178C249.726 73.4952 255.836 82.9625 255.897 83.0571C255.946 83.1339 256.013 83.1971 256.093 83.2408C256.173 83.2845 256.263 83.3074 256.354 83.3072Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M260.227 146.527C260.322 146.527 260.415 146.502 260.498 146.454C260.58 146.407 260.648 146.339 260.696 146.257C260.744 146.175 260.769 146.082 260.77 145.987C260.77 145.892 260.746 145.798 260.699 145.716C260.634 145.601 254.071 134.164 243.634 124.97C237.481 119.549 231.2 115.949 224.966 114.272C217.139 112.166 209.381 113.098 201.908 117.042C201.844 117.075 201.788 117.12 201.742 117.175C201.696 117.23 201.662 117.293 201.641 117.362C201.619 117.43 201.612 117.502 201.618 117.573C201.625 117.644 201.645 117.713 201.679 117.776C201.712 117.84 201.758 117.895 201.813 117.941C201.868 117.987 201.931 118.021 202 118.042C202.068 118.063 202.14 118.07 202.211 118.063C202.282 118.056 202.351 118.035 202.414 118.002C215.556 111.066 229.182 113.685 242.916 125.784C253.218 134.86 259.691 146.139 259.755 146.252C259.802 146.336 259.871 146.405 259.954 146.453C260.037 146.502 260.131 146.527 260.227 146.527Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250.457 194.281C250.552 194.281 250.645 194.256 250.727 194.208C250.809 194.161 250.878 194.093 250.925 194.011C250.973 193.929 250.999 193.836 250.999 193.741C251 193.646 250.975 193.552 250.928 193.47C250.863 193.355 244.3 181.918 233.863 172.724C227.71 167.303 221.429 163.703 215.196 162.026C207.369 159.92 199.611 160.851 192.137 164.796C192.074 164.829 192.018 164.875 191.973 164.929C191.927 164.984 191.893 165.048 191.872 165.116C191.851 165.184 191.843 165.255 191.85 165.326C191.857 165.397 191.877 165.466 191.91 165.529C191.944 165.592 191.989 165.648 192.044 165.694C192.099 165.739 192.162 165.773 192.23 165.794C192.298 165.815 192.37 165.823 192.441 165.816C192.512 165.809 192.581 165.789 192.644 165.756C205.785 158.82 219.412 161.438 233.146 173.538C243.448 182.614 249.92 193.893 249.984 194.006C250.032 194.09 250.1 194.159 250.183 194.207C250.266 194.256 250.361 194.281 250.457 194.281Z",
    fill: "white"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M215.851 213.014C228.044 194.29 227.289 186.676 243.763 160.387C262.347 130.73 273.63 113.398 294.206 113.564C308.234 113.677 324.708 121.908 331.834 132.608C343.758 150.514 328.603 173.978 323.425 181.996C314.746 195.432 305.927 199.526 306.352 212.095C306.711 222.702 313.186 225.516 313.315 233.452C313.683 255.981 262.029 265.772 253.667 267.357C220.902 273.567 189.282 269.349 165.134 263.335C191.624 245.385 206.802 226.91 215.851 213.014Z",
    fill: "#D8DEE8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_18300_185650",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 113,
    width: 172,
    height: 158
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215.853 213.014C228.046 194.29 227.291 186.676 243.765 160.387C262.349 130.73 273.632 113.398 294.208 113.564C308.236 113.677 324.71 121.908 331.836 132.608C343.76 150.514 328.605 173.978 323.427 181.996C314.748 195.432 305.929 199.526 306.354 212.095C306.713 222.702 313.188 225.516 313.317 233.452C313.685 255.981 262.031 265.772 253.669 267.357C220.904 273.567 189.284 269.349 165.136 263.335C191.626 245.385 206.804 226.91 215.853 213.014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_18300_185650)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M160.01 264.822C160.041 264.822 160.072 264.819 160.103 264.814C188.539 260.131 214.739 249.739 237.974 233.928C256.558 221.281 273.296 205.158 287.723 186.009C312.281 153.41 321.746 122.904 321.839 122.6C321.883 122.456 321.867 122.301 321.797 122.168C321.726 122.035 321.605 121.936 321.461 121.892C321.317 121.848 321.161 121.863 321.029 121.934C320.896 122.005 320.796 122.125 320.752 122.269C320.66 122.572 311.241 152.917 286.791 185.359C264.244 215.277 223.93 253.153 159.919 263.694C159.778 263.717 159.651 263.793 159.563 263.905C159.476 264.017 159.433 264.158 159.445 264.3C159.457 264.442 159.521 264.575 159.626 264.671C159.73 264.768 159.868 264.822 160.01 264.822Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M286.441 187.328C286.539 187.328 286.636 187.303 286.721 187.254C286.806 187.205 286.878 187.135 286.928 187.051C286.978 186.966 287.006 186.87 287.008 186.772C287.01 186.674 286.986 186.577 286.939 186.49C286.787 186.209 271.72 157.92 274.947 118.962C274.959 118.812 274.911 118.663 274.814 118.548C274.717 118.434 274.578 118.362 274.428 118.35C274.278 118.337 274.129 118.385 274.014 118.482C273.899 118.579 273.827 118.718 273.815 118.868C270.559 158.18 285.787 186.748 285.941 187.032C285.99 187.121 286.062 187.196 286.15 187.249C286.238 187.301 286.338 187.328 286.441 187.328Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M288.353 187.243C291.545 187.243 298.303 186.986 306.801 185.203C317.765 182.902 333.972 177.518 348.919 164.935C348.976 164.887 349.023 164.828 349.057 164.762C349.092 164.696 349.113 164.624 349.119 164.549C349.125 164.475 349.117 164.4 349.095 164.329C349.072 164.258 349.036 164.192 348.988 164.135C348.891 164.02 348.752 163.949 348.602 163.936C348.452 163.923 348.303 163.97 348.188 164.067C333.434 176.487 317.432 181.808 306.607 184.084C294.863 186.553 286.503 186.073 286.42 186.068C286.27 186.059 286.122 186.109 286.009 186.209C285.897 186.309 285.828 186.449 285.819 186.599C285.809 186.749 285.86 186.897 285.96 187.01C286.059 187.123 286.2 187.191 286.35 187.201C286.374 187.202 287.08 187.243 288.353 187.243Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M276.165 231.034C289.716 231.034 310.786 227.122 340.122 211.03C340.188 210.994 340.245 210.946 340.292 210.887C340.339 210.829 340.373 210.763 340.394 210.691C340.415 210.619 340.422 210.545 340.414 210.47C340.405 210.396 340.383 210.325 340.347 210.259C340.311 210.194 340.263 210.136 340.205 210.09C340.146 210.043 340.08 210.008 340.008 209.987C339.937 209.967 339.862 209.96 339.787 209.968C339.713 209.976 339.642 209.999 339.576 210.035C306.761 228.035 284.434 230.682 271.484 229.732C257.492 228.706 251.151 223.376 251.089 223.322C250.975 223.224 250.827 223.175 250.677 223.185C250.526 223.196 250.387 223.266 250.288 223.38C250.19 223.494 250.141 223.642 250.152 223.792C250.162 223.943 250.232 224.082 250.346 224.181C250.609 224.409 256.958 229.775 271.274 230.854C272.779 230.968 274.41 231.034 276.165 231.034Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M298.302 285.758C298.448 285.758 298.588 285.702 298.693 285.601C298.798 285.501 298.861 285.364 298.868 285.219C298.876 285.073 298.827 284.931 298.732 284.82C298.637 284.71 298.503 284.64 298.358 284.626C261.029 280.868 241.117 270.367 230.986 262.22C220.09 253.456 217.929 245.546 217.908 245.467C217.87 245.321 217.776 245.197 217.646 245.121C217.516 245.045 217.362 245.023 217.216 245.061C217.071 245.099 216.946 245.193 216.87 245.323C216.794 245.453 216.772 245.607 216.81 245.753C216.897 246.09 219.088 254.107 230.275 263.104C240.525 271.348 260.638 281.969 298.244 285.755C298.264 285.757 298.283 285.758 298.302 285.758Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M247.97 226.499C248.082 226.499 248.191 226.466 248.283 226.405C248.376 226.344 248.449 226.256 248.493 226.154C248.536 226.051 248.549 225.938 248.529 225.829C248.509 225.72 248.457 225.618 248.38 225.538C248.327 225.483 243.045 219.91 239.33 209.25C235.901 199.411 233.144 183.098 239.478 161.257C239.499 161.186 239.505 161.111 239.497 161.037C239.489 160.963 239.466 160.891 239.431 160.825C239.395 160.76 239.346 160.702 239.288 160.656C239.23 160.609 239.163 160.574 239.091 160.554C239.02 160.533 238.945 160.526 238.87 160.535C238.796 160.543 238.724 160.566 238.659 160.602C238.594 160.638 238.536 160.686 238.49 160.745C238.443 160.803 238.408 160.87 238.388 160.941C231.96 183.103 234.781 199.682 238.28 209.687C242.082 220.559 247.34 226.095 247.562 226.325C247.615 226.38 247.678 226.424 247.748 226.454C247.819 226.484 247.894 226.499 247.97 226.499Z",
    fill: "white"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5251 121.89L25.4035 119.276C24.8702 115.369 24.6822 111.423 24.8417 107.482L16.748 105.771C16.2058 105.653 15.6921 105.43 15.2365 105.113C14.7808 104.797 14.3922 104.394 14.0928 103.927C13.7934 103.46 13.5892 102.938 13.4919 102.392C13.3946 101.846 13.4061 101.287 13.5257 100.745L16.6007 86.4276C16.8311 85.3339 17.4855 84.376 18.4208 83.7635C19.3561 83.151 20.496 82.9339 21.591 83.1597L29.6611 84.8665C31.1114 81.2329 32.88 77.7344 34.9461 74.4119L28.8474 68.8959C28.0235 68.1461 27.5298 67.1008 27.4742 65.9883C27.4187 64.8758 27.8057 63.7865 28.5508 62.9584L38.2298 52.172C38.5954 51.7628 39.0382 51.4299 39.5329 51.1922C40.0275 50.9546 40.5643 50.817 41.1123 50.7872C41.6602 50.7574 42.2087 50.8362 42.7262 51.0188C43.2437 51.2015 43.72 51.4845 44.1278 51.8517L50.2653 57.3862C53.3052 55.0013 56.5484 52.8874 59.9577 51.069L57.3918 43.1898C57.0483 42.1382 57.1361 40.9932 57.6361 40.0062C58.1361 39.0193 59.0073 38.2709 60.0586 37.9254L73.7169 33.4586C74.7672 33.1172 75.91 33.2065 76.8945 33.7068C77.879 34.2071 78.6246 35.0776 78.9675 36.1271L81.5617 44.025C85.3584 43.4964 89.1946 43.306 93.025 43.456L94.7089 35.2795C94.818 34.7455 95.0318 34.2383 95.338 33.7873C95.6441 33.3363 96.0366 32.9504 96.4926 32.6517C96.9487 32.3531 97.4594 32.1476 97.9953 32.0472C98.5312 31.9468 99.0817 31.9535 99.615 32.0668L113.663 35.0381C114.744 35.2689 115.691 35.9166 116.298 36.8406C116.904 37.7646 117.122 38.8904 116.904 39.9739L115.23 48.2211C118.783 49.6516 122.203 51.3911 125.451 53.4195L131.008 47.134C131.371 46.7264 131.811 46.3945 132.302 46.1577C132.794 45.9209 133.327 45.7837 133.872 45.7541C134.417 45.7245 134.963 45.8031 135.477 45.9853C135.991 46.1675 136.464 46.4498 136.869 46.8158L147.645 56.4505C148.474 57.187 148.979 58.2204 149.05 59.3267C149.122 60.4329 148.755 61.5227 148.028 62.3599L142.422 68.733C144.794 71.7566 146.904 74.9773 148.727 78.3598L156.798 75.6822C158.974 74.9602 161.339 76.1621 162.081 78.3674L166.731 92.1844C167.476 94.398 166.313 96.7826 164.132 97.5096L156.034 100.21C156.607 104.028 156.85 107.889 156.759 111.749L165.197 113.533C166.294 113.774 167.252 114.434 167.868 115.373C168.484 116.311 168.709 117.453 168.494 118.554L165.703 132.931C165.602 133.475 165.394 133.992 165.091 134.454C164.788 134.915 164.395 135.312 163.936 135.619C163.478 135.927 162.962 136.14 162.42 136.245C161.877 136.351 161.319 136.347 160.779 136.234L152.315 134.444C150.941 138.057 149.254 141.543 147.273 144.863L153.749 150.702C154.589 151.461 155.1 152.518 155.173 153.647C155.246 154.777 154.876 155.89 154.141 156.751L144.553 167.816C144.19 168.237 143.746 168.58 143.248 168.826C142.75 169.072 142.207 169.215 141.652 169.248C141.097 169.28 140.542 169.201 140.018 169.014C139.495 168.828 139.014 168.539 138.605 168.163L132.13 162.307C129.127 164.738 125.917 166.902 122.536 168.773L125.279 177.126C126.022 179.387 124.832 181.828 122.619 182.577L108.768 187.262C106.551 188.013 104.154 186.782 103.415 184.515L100.716 176.226C96.8793 176.801 92.9984 177.031 89.1205 176.911L87.3864 185.458C86.9117 187.798 84.6688 189.303 82.3767 188.818L68.0443 185.787C65.7527 185.302 64.2854 183.012 64.767 180.674L66.5119 172.2C62.8812 170.749 59.388 168.975 56.0744 166.899L50.436 173.31C50.0701 173.732 49.6232 174.076 49.1219 174.323C48.6206 174.57 48.0749 174.714 47.5171 174.746C46.9593 174.779 46.4005 174.699 45.8739 174.513C45.3473 174.326 44.8634 174.035 44.4508 173.659L33.5836 163.745C32.7486 162.973 32.2493 161.904 32.1926 160.768C32.1359 159.632 32.5263 158.519 33.2802 157.667L38.9 151.311C36.49 148.197 34.3573 144.878 32.5262 141.392L24.5715 144.044C24.0431 144.22 23.485 144.289 22.9298 144.246C22.3746 144.204 21.8335 144.051 21.3381 143.796C20.8428 143.542 20.4031 143.192 20.045 142.765C19.6869 142.339 19.4174 141.846 19.2525 141.314L14.7953 127.279C14.4534 126.202 14.5478 125.034 15.0583 124.026C15.5688 123.019 16.4546 122.252 17.5251 121.89ZM80.5307 160.327C108.252 166.19 135.261 148.125 140.827 120.13C146.359 92.3045 128.591 65.1683 101.17 59.3687C73.7506 53.5693 46.8199 71.2514 40.9874 99.0138C35.12 126.944 52.8097 154.464 80.5307 160.327Z",
    fill: "#D8DEE8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M174.696 67.0678L153.606 281.78C153.294 284.957 155.498 287.835 158.514 288.177L264.496 301.335C271.083 301.839 274.643 298.51 275.001 295.078L299.191 62.9658C299.556 59.4547 296.222 56.3467 289.491 56.4807L180.893 60.9602C177.798 61.0741 175.014 63.8228 174.696 67.0678Z",
    fill: "url(#paint1_linear_18300_185650)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M169.93 66.7842L148.799 282.421C148.487 285.612 150.696 288.502 153.719 288.847L263.483 301.353C266.977 301.751 270.141 299.258 270.499 295.811L294.748 62.649C295.115 59.1218 292.465 56.3444 288.873 56.4772L176.142 60.6492C173.04 60.764 170.249 63.525 169.93 66.7842Z",
    fill: "url(#paint2_linear_18300_185650)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M172.233 78.7679L152.608 278.705C152.315 281.688 154.385 284.385 157.218 284.699L260.473 296.153C263.72 296.513 266.658 294.184 266.991 290.975L289.326 75.8146C289.666 72.5372 287.21 69.9339 283.88 70.0299L178.044 73.0823C175.142 73.1659 172.532 75.7247 172.233 78.7679Z",
    fill: "url(#paint3_linear_18300_185650)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M227.725 65.5472C227.607 66.7198 228.445 67.6409 229.599 67.6047C230.754 67.5684 231.788 66.586 231.907 65.4105C232.026 64.2348 231.184 63.3134 230.028 63.3528C228.873 63.3921 227.843 64.3746 227.725 65.5472Z",
    fill: "url(#paint4_linear_18300_185650)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M218.399 255.577C189.815 255.577 166.643 232.412 166.643 203.837C166.643 175.262 189.815 152.098 218.399 152.098C246.983 152.098 270.154 175.262 270.154 203.837C270.154 232.412 246.983 255.577 218.399 255.577Z",
    fill: "white"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.24 194.746C175.248 196.921 176.002 199.029 177.376 200.716C178.75 202.403 180.661 203.569 182.791 204.018L217.21 211.319L219.028 203.039L221.123 193.491L186.942 185.492C182.129 184.369 177.215 187.126 175.702 191.83C175.688 191.872 175.62 191.914 175.62 191.956V191.961C175.62 192.888 175.24 193.824 175.24 194.746Z",
    fill: "url(#paint5_linear_18300_185650)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.392 194.755C177.958 192.918 179.097 191.077 180.935 190.643C182.773 190.209 184.614 191.347 185.048 193.185C185.482 195.022 184.344 196.863 182.506 197.297C180.668 197.731 178.826 196.593 178.392 194.755Z",
    fill: "url(#paint6_linear_18300_185650)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M175.285 194.746C175.288 196.92 176.037 199.026 177.407 200.714C178.778 202.401 180.686 203.568 182.813 204.018L217.22 211.319L219.032 203.04C212.562 201.996 196.695 199.473 187.635 198.317C176.788 196.932 175.795 192.509 175.711 191.961C175.428 192.862 175.284 193.801 175.285 194.746Z",
    fill: "url(#paint7_linear_18300_185650)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M214.569 194.764L226.624 208.469L230.07 205.525L253.311 185.666C255.073 184.158 256.223 182.057 256.543 179.76C256.863 177.463 256.331 175.129 255.048 173.197C254.978 173.094 254.908 172.991 254.837 172.893C254.059 171.816 253.064 170.915 251.915 170.248C250.767 169.58 249.491 169.161 248.17 169.017C246.849 168.873 245.513 169.008 244.248 169.413C242.983 169.817 241.816 170.483 240.825 171.367L214.569 194.764Z",
    fill: "#F4F7FA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M223.703 200.754L230.07 205.523L253.311 185.664C255.073 184.156 256.223 182.056 256.543 179.759C256.863 177.462 256.331 175.127 255.048 173.195L223.703 200.754Z",
    fill: "#F4F7FA"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M211.672 209.385C206.707 204.422 206.707 196.375 211.672 191.412C216.636 186.449 224.685 186.449 229.65 191.412C234.614 196.375 234.614 204.422 229.65 209.385C224.685 214.348 216.636 214.348 211.672 209.385Z",
    fill: "url(#paint8_linear_18300_185650)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M261.988 216.426C261.988 216.426 269.412 220.756 267.197 225.855C265.865 228.922 262.616 229.997 260.237 230.367C259.882 230.421 259.52 230.402 259.173 230.311C258.825 230.22 258.5 230.06 258.217 229.84C257.933 229.619 257.698 229.344 257.524 229.03C257.351 228.715 257.243 228.369 257.208 228.012L256.779 223.795L261.988 216.426Z",
    fill: "url(#paint9_linear_18300_185650)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M172.861 173.675C173.309 177.833 170.292 189.813 166.133 190.261L131.87 185.704L130.248 170.647L164.52 166.958C165.509 166.851 166.509 166.94 167.463 167.22C168.418 167.5 169.308 167.965 170.082 168.589C170.857 169.213 171.501 169.983 171.978 170.856C172.454 171.728 172.755 172.686 172.861 173.675Z",
    fill: "url(#paint10_linear_18300_185650)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M106.824 145.023C107.597 144.397 108.486 143.93 109.439 143.648C110.393 143.365 111.393 143.273 112.382 143.377C113.371 143.481 114.33 143.779 115.204 144.254C116.079 144.728 116.851 145.37 117.476 146.143L139.167 172.925L127.394 182.454L105.703 155.672C105.077 154.9 104.61 154.011 104.328 153.058C104.045 152.104 103.953 151.105 104.057 150.116C104.161 149.127 104.459 148.168 104.934 147.294C105.409 146.42 106.051 145.649 106.824 145.023Z",
    fill: "url(#paint11_linear_18300_185650)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M131.133 188.589C125.231 187.174 121.593 181.244 123.008 175.343C124.422 169.443 130.354 165.806 136.257 167.22C142.159 168.635 145.797 174.565 144.382 180.465C142.968 186.366 137.036 190.003 131.133 188.589Z",
    fill: "url(#paint12_linear_18300_185650)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M149.146 142.115C139.763 142.115 132.158 131.43 132.158 118.249C132.158 105.068 139.763 94.3828 149.146 94.3828C158.528 94.3828 166.134 105.068 166.134 118.249C166.134 131.43 158.528 142.115 149.146 142.115Z",
    fill: "url(#paint13_linear_18300_185650)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M201.068 60.418H233.042C265.827 60.418 292.404 86.9872 292.404 119.762C292.404 137.251 278.222 151.429 260.728 151.429H173.382C155.888 151.429 141.706 137.251 141.706 119.762C141.706 86.9874 168.283 60.418 201.068 60.418Z",
    fill: "url(#paint14_linear_18300_185650)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M203.418 234.333H229.92C257.093 234.333 279.122 212.311 279.122 185.146C279.122 170.65 267.367 158.898 252.867 158.898H180.47C165.97 158.898 154.215 170.65 154.215 185.145C154.215 212.311 176.244 234.333 203.418 234.333Z",
    fill: "url(#paint15_linear_18300_185650)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M172.044 138.628H232.822C241.059 138.628 247.816 132.316 247.816 124.531V112.592C247.816 104.806 241.059 98.7104 232.822 98.973L172.044 100.911C164.688 101.146 158.792 107.199 158.792 114.434V125.528C158.792 132.763 164.688 138.628 172.044 138.628Z",
    fill: "url(#paint16_linear_18300_185650)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M213.349 120.79C213.349 121.062 213.361 121.529 213.386 121.529H233.295C233.35 121.15 233.378 120.767 233.379 120.383C233.379 115.102 228.837 110.943 223.282 111.098C217.777 111.253 213.349 115.592 213.349 120.79Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M172.274 121.531H190.963C190.968 121.531 190.972 121.365 190.972 121.248C190.972 116.143 186.736 112.092 181.549 112.234C176.417 112.381 172.29 116.531 172.274 121.531Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M194.999 143.105C204.038 132.488 200.021 123.997 211.839 109.609C228.098 89.8119 247.067 92.0521 251.412 78.625C252.615 74.9044 252.754 69.7976 249.525 62.7383C274.29 69.8796 292.404 92.7051 292.404 119.762C292.404 137.251 278.222 151.429 260.728 151.429H184.607C189.167 148.944 192.499 146.042 194.999 143.105Z",
    fill: "white"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M283.861 141.951C274.478 141.951 266.872 131.266 266.872 118.085C266.872 104.904 274.478 94.2188 283.861 94.2188C293.243 94.2188 300.849 104.904 300.849 118.085C300.849 131.266 293.243 141.951 283.861 141.951Z",
    fill: "url(#paint17_linear_18300_185650)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M297.301 128.521C293.198 128.521 289.872 123.848 289.872 118.085C289.872 112.321 293.198 107.648 297.301 107.648C301.404 107.648 304.729 112.321 304.729 118.085C304.729 123.848 301.404 128.521 297.301 128.521Z",
    fill: "url(#paint18_linear_18300_185650)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M196.891 207.254C200.527 190.184 240.745 190.596 241.839 179.438C242.682 170.837 219.591 162.321 216.69 161.251C214.208 160.336 211.745 159.561 209.306 158.898H252.867C267.367 158.898 279.122 170.65 279.122 185.145C279.122 212.311 257.094 234.333 229.92 234.333H203.418C200.911 234.334 198.407 234.144 195.928 233.767C198.235 230.909 199.738 227.783 200.102 224.372C200.908 216.81 195.482 213.869 196.891 207.254Z",
    fill: "url(#paint19_linear_18300_185650)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M216.015 165.425C192.899 165.425 174.16 163.157 174.16 160.359C174.16 157.561 192.899 155.293 216.015 155.293C239.131 155.293 257.87 157.561 257.87 160.359C257.87 163.157 239.131 165.425 216.015 165.425Z",
    fill: "url(#paint20_linear_18300_185650)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M299.637 186.44L273.72 170.651C272.794 170.087 271.764 169.712 270.692 169.548C269.62 169.384 268.525 169.433 267.472 169.695C266.419 169.956 265.429 170.423 264.558 171.07C263.687 171.716 262.952 172.529 262.397 173.461C261.842 174.393 261.478 175.426 261.325 176.499C261.172 177.573 261.233 178.666 261.505 179.716C261.777 180.766 262.255 181.752 262.911 182.616C263.566 183.48 264.387 184.205 265.325 184.75L291.615 200.028L299.637 186.44Z",
    fill: "url(#paint21_linear_18300_185650)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M248.466 206.804L247.363 213.345C247.286 213.809 247.316 214.284 247.451 214.735C247.586 215.185 247.822 215.599 248.141 215.944C248.461 216.289 248.855 216.556 249.294 216.725C249.732 216.895 250.204 216.961 250.673 216.92C254.93 216.572 261.381 217.032 263.912 222.399C264.57 223.816 264.722 225.416 264.341 226.931L263.733 229.397C263.733 229.397 275.615 225.483 269.999 212.028C265.59 201.462 255.017 203.141 250.68 204.35C250.116 204.506 249.608 204.82 249.216 205.255C248.824 205.689 248.564 206.227 248.466 206.804Z",
    fill: "url(#paint22_linear_18300_185650)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M294.324 190.379L268.486 206.296C267.562 206.865 266.761 207.611 266.127 208.492C265.494 209.372 265.042 210.37 264.797 211.426C264.551 212.483 264.518 213.577 264.699 214.647C264.88 215.716 265.271 216.739 265.849 217.656C266.428 218.574 267.183 219.367 268.07 219.991C268.958 220.615 269.96 221.057 271.019 221.291C272.079 221.525 273.174 221.547 274.242 221.355C275.309 221.164 276.329 220.762 277.24 220.174L302.793 203.693L294.324 190.379Z",
    fill: "url(#paint23_linear_18300_185650)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M289.262 203.495C284.97 199.205 284.97 192.248 289.262 187.958C293.554 183.667 300.513 183.667 304.805 187.958C309.097 192.248 309.097 199.205 304.805 203.495C300.513 207.786 293.554 207.786 289.262 203.495Z",
    fill: "url(#paint24_linear_18300_185650)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M109.355 132.282L116.772 126.945C116.772 126.945 119.279 134.611 118.449 136.687C117.618 138.762 109.73 145.818 109.73 145.818C109.73 145.818 110.38 139.86 108.515 135.228C108.304 134.714 108.273 134.144 108.425 133.609C108.578 133.075 108.905 132.607 109.355 132.282Z",
    fill: "url(#paint25_linear_18300_185650)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M116.771 126.945C116.612 126.945 116.456 126.982 116.315 127.054C116.174 127.125 116.051 127.229 115.958 127.357C115.865 127.485 115.803 127.633 115.778 127.79C115.753 127.946 115.765 128.106 115.814 128.257C116.928 131.672 118.965 140.716 110.144 142.705C101.922 144.559 98.4693 139.999 95.5977 132.956C95.4983 132.714 95.3505 132.494 95.1632 132.31C94.9759 132.127 94.7532 131.984 94.5086 131.889C94.264 131.795 94.0028 131.751 93.7408 131.761C93.4788 131.771 93.2216 131.835 92.985 131.947L86.5762 134.997C86.3243 135.116 86.1013 135.289 85.9226 135.503C85.7439 135.717 85.6137 135.967 85.541 136.236C85.4683 136.505 85.4549 136.786 85.5016 137.061C85.5484 137.336 85.6542 137.597 85.8117 137.827C88.816 142.178 97.2483 152.152 109.106 148.101C123.587 143.153 118.969 130.449 117.69 127.543C117.612 127.365 117.483 127.214 117.32 127.107C117.156 127.001 116.966 126.945 116.771 126.945Z",
    fill: "url(#paint26_linear_18300_185650)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3433 49.1643C29.3433 35.7952 41.679 25.3585 56.3716 25.8361C64.7388 26.1081 72.0186 29.8789 76.5642 35.4454L76.5659 35.4406C76.5941 35.4752 76.6205 35.5112 76.6485 35.5459C76.7271 35.6433 76.803 35.7425 76.88 35.841C77.0203 36.0206 77.1582 36.2017 77.2935 36.3845C77.3731 36.4928 77.4517 36.6017 77.5293 36.7112C77.6589 36.8939 77.7857 37.0784 77.9095 37.2647C77.9805 37.3713 78.0523 37.4773 78.1214 37.5849C78.2598 37.7999 78.393 38.0178 78.5238 38.2371C78.5712 38.3164 78.621 38.3943 78.6673 38.4743C78.8398 38.7714 79.0052 39.0722 79.1637 39.3766C79.2057 39.4574 79.2441 39.5398 79.2852 39.621C79.4005 39.8494 79.5131 40.0789 79.6205 40.3111C79.6732 40.4249 79.7229 40.5399 79.7736 40.6546C79.8643 40.8601 79.9519 41.0668 80.0366 41.2748C80.0856 41.3957 80.1336 41.517 80.1805 41.6387C80.2626 41.8524 80.3404 42.0677 80.4157 42.2841C80.4551 42.3973 80.4959 42.5098 80.5334 42.6237C80.6231 42.8961 80.7064 43.1707 80.7853 43.447C80.8017 43.5047 80.8207 43.5614 80.8366 43.6193C80.9286 43.9526 81.0123 44.2888 81.0876 44.6278C81.11 44.7275 81.1283 44.8285 81.1492 44.9287C81.1999 45.1716 81.2479 45.4153 81.2903 45.6609C81.3117 45.7859 81.3307 45.9115 81.35 46.0372C81.3849 46.2644 81.4162 46.4925 81.4438 46.7216C81.4593 46.8502 81.4744 46.9788 81.4875 47.108C81.5121 47.3496 81.531 47.5927 81.5473 47.8364C81.5549 47.9498 81.5645 48.0627 81.5704 48.1765C81.5884 48.5327 81.5996 48.8904 81.5996 49.2506C81.5996 57.8297 76.4021 65.3973 68.6102 69.4491C67.8936 69.8217 67.1553 70.1643 66.3954 70.4768C66.0152 70.6329 65.63 70.7811 65.2396 70.9213C62.3897 71.939 59.3967 72.4995 56.3716 72.5819C55.939 72.5946 55.5086 72.5966 55.0802 72.5904C54.9356 72.5883 54.7927 72.5803 54.6485 72.5761C54.3653 72.5679 54.0819 72.5595 53.8006 72.5432C53.6287 72.5332 53.4587 72.5177 53.2875 72.5048C53.0363 72.4857 52.785 72.4667 52.5358 72.4413C52.3532 72.4227 52.1721 72.3996 51.9905 72.3776C51.7548 72.3491 51.5192 72.3199 51.2853 72.2858C51.0986 72.2585 50.9133 72.2278 50.7278 72.197C50.5015 72.1594 50.2758 72.1203 50.0515 72.0775C49.8637 72.0417 49.6767 72.0039 49.4906 71.9641C49.271 71.9177 49.0524 71.8687 48.8349 71.8173C48.6484 71.7732 48.4624 71.728 48.2775 71.6803C48.0624 71.6248 47.849 71.566 47.6361 71.5058C47.453 71.4539 47.2699 71.4021 47.0885 71.3467C47.0216 71.3263 46.9529 71.3089 46.8863 71.288L46.8907 71.2831C36.7255 68.1003 29.3433 59.4712 29.3433 49.1643Z",
    fill: "url(#paint27_linear_18300_185650)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3617 49.1689C31.3617 62.5036 43.6345 72.9551 58.2535 72.5282C72.3279 72.1171 83.3584 61.7034 83.3584 49.2548C83.3584 36.8062 72.3279 26.356 58.2535 25.8985C43.6345 25.4232 31.3617 35.8342 31.3617 49.1689Z",
    fill: "url(#paint28_linear_18300_185650)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9353 35.4642L63.8733 42.7076L71.8192 43.6612C72.9651 43.7988 73.5075 45.2277 72.7372 46.0842L67.3711 52.051L69.2009 60.2633C69.4699 61.4707 68.2986 62.4706 67.2157 61.9511L59.7394 58.365L52.4835 62.7674C51.4066 63.4208 50.0807 62.535 50.2449 61.2698L51.3566 52.7071L45.0706 46.9838C44.8638 46.7964 44.7138 46.5546 44.6378 46.2861C44.5617 46.0176 44.5627 45.7331 44.6405 45.4651C44.7183 45.1972 44.8699 44.9564 45.078 44.7704C45.2861 44.5844 45.5423 44.4605 45.8173 44.413L54.0688 42.9743L57.3763 35.5067C57.8518 34.4331 59.3624 34.4104 59.9353 35.4642Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8966 66.7236C55.0689 59.7417 51.8617 53.29 56.145 48.812C60.4474 44.3139 65.9657 48.5185 71.8151 44.9192C74.0521 43.5427 76.5236 40.9089 78.3499 35.4766C81.5004 39.343 83.3594 44.1111 83.3594 49.2532C83.3594 61.7018 72.3289 72.1156 58.2545 72.5266C55.0585 72.6251 51.8685 72.1887 48.8165 71.2352C50.0934 69.9182 51.1352 68.3923 51.8966 66.7236Z",
    fill: "url(#paint29_linear_18300_185650)"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2157 98.2915C74.2157 98.9917 74.1874 99.6849 74.2609 100.368C74.2924 100.662 74.2976 100.952 74.3431 101.239C74.4341 101.817 74.533 102.388 74.6766 102.948C74.7467 103.228 74.8153 103.508 74.8958 103.784C74.9519 103.966 75.0073 104.152 75.0668 104.334C76.4956 108.612 79.4036 112.319 83.2802 115.085C83.3643 115.145 83.4438 115.204 83.5278 115.26C84.8877 116.205 86.3318 117.023 87.8417 117.704C87.9363 117.746 88.0306 117.788 88.1286 117.83C88.8045 118.127 89.4978 118.4 90.2086 118.649C90.5097 118.754 90.8179 118.856 91.126 118.95C91.3326 119.017 91.5393 119.08 91.7493 119.139C92.061 119.23 92.3761 119.314 92.6948 119.395C92.905 119.447 93.1185 119.5 93.3321 119.549C96.0981 120.182 98.9372 120.437 101.772 120.308C101.989 120.298 102.206 120.287 102.42 120.273C102.483 120.27 102.546 120.263 102.605 120.259C102.623 120.259 102.64 120.256 102.658 120.256C102.794 120.245 102.931 120.238 103.064 120.224C103.134 120.217 103.201 120.214 103.267 120.207C103.414 120.193 103.565 120.179 103.712 120.165C103.775 120.158 103.838 120.147 103.901 120.14C104.052 120.126 104.206 120.109 104.356 120.088C104.412 120.081 104.465 120.074 104.521 120.067C104.682 120.046 104.843 120.025 105.008 120C105.046 119.993 105.088 119.986 105.13 119.979C105.309 119.955 105.484 119.927 105.663 119.895C105.687 119.892 105.711 119.644 105.732 119.641C105.932 119.606 106.132 119.288 106.328 119.288H106.331C107.998 119.288 109.602 118.765 111.125 118.202C111.122 118.198 111.122 118.32 111.118 118.317C111.595 118.142 112.064 118.014 112.526 117.814C112.936 117.636 113.339 117.481 113.734 117.288C113.927 117.442 114.151 117.618 114.4 117.79C117.583 116.421 120.388 114.545 122.664 112.284C122.393 111.92 122.141 111.543 121.908 111.153C125.189 107.414 127.115 102.82 127.115 97.922C127.115 86.1767 116.039 76.3193 101.772 75.8887C101.306 75.8747 100.967 75.8716 100.508 75.8786C86.5284 76.0572 74.7864 85.3349 74.3563 97.2938V97.8364C74.3563 97.9869 74.2157 98.1375 74.2157 98.2915Z",
    fill: "url(#paint30_linear_18300_185650)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9837 98.2105C75.9837 110.754 88.1212 120.437 102.658 120.255C102.994 120.252 103.334 120.241 103.673 120.227C103.981 120.213 104.29 120.196 104.594 120.171C104.906 120.15 105.218 120.122 105.526 120.091C105.589 120.084 105.652 120.08 105.715 120.07C105.915 120.049 106.111 120.028 106.31 120C106.506 119.975 106.699 119.951 106.895 119.919C107.175 119.881 107.455 119.835 107.732 119.786C107.9 119.755 108.065 119.727 108.229 119.695C109.86 119.382 111.463 118.935 113.02 118.358C113.489 118.183 113.948 118.001 114.4 117.805C117.476 116.501 120.28 114.631 122.664 112.291C126.639 108.356 129.017 103.287 129.017 97.8429C129.017 86.0975 117.94 76.2391 103.673 75.8085C102.577 75.7738 101.479 75.7972 100.385 75.8785C88.7848 76.7162 79.1152 83.8257 76.6165 93.3459L76.6155 93.3496C76.5527 93.5891 76.4937 93.8297 76.44 94.0722C76.4226 94.1503 76.407 94.2289 76.3906 94.3074C76.3504 94.5002 76.3099 94.6929 76.2757 94.8875C76.2248 95.1731 76.1791 95.4602 76.1411 95.7494C76.1447 95.7529 76.1411 95.7564 76.1411 95.7634C76.1271 95.8718 76.1131 95.9839 76.1027 96.0924C76.0851 96.2289 76.071 96.3655 76.0606 96.5021C76.0466 96.6526 76.0326 96.8066 76.0256 96.9571C76.0221 97.0027 76.0186 97.0517 76.0151 97.0971C76.0045 97.2722 75.9975 97.4472 75.9941 97.6223C75.9871 97.8183 75.9836 98.0144 75.9837 98.2105Z",
    fill: "url(#paint31_linear_18300_185650)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9837 98.2105C75.9837 110.754 88.1212 120.437 102.658 120.255C102.994 120.252 103.334 120.241 103.673 120.227C103.981 120.213 104.29 120.196 104.594 120.171C104.906 120.15 105.218 120.122 105.526 120.091C105.589 120.084 105.652 120.08 105.715 120.07C105.915 120.049 106.111 120.028 106.31 120C106.506 119.975 106.699 119.951 106.895 119.919C107.175 119.881 107.455 119.835 107.732 119.786C107.9 119.755 108.065 119.727 108.229 119.695C109.86 119.382 111.463 118.935 113.02 118.358C113.489 118.183 113.948 118.001 114.4 117.805C117.476 116.501 120.28 114.631 122.664 112.291C126.639 108.356 129.017 103.287 129.017 97.8429C129.017 86.0975 117.94 76.2391 103.673 75.8085C102.577 75.7738 101.479 75.7972 100.385 75.8785C88.7848 76.7162 79.1152 83.8257 76.6165 93.3459L76.6155 93.3496C76.5527 93.5891 76.4937 93.8297 76.44 94.0722C76.4226 94.1503 76.407 94.2289 76.3906 94.3074C76.3504 94.5002 76.3099 94.6929 76.2757 94.8875C76.2248 95.1731 76.1791 95.4602 76.1411 95.7494C76.1447 95.7529 76.1411 95.7564 76.1411 95.7634C76.1271 95.8718 76.1131 95.9839 76.1027 96.0924C76.0851 96.2289 76.071 96.3655 76.0606 96.5021C76.0466 96.6526 76.0326 96.8066 76.0256 96.9571C76.0221 97.0027 76.0186 97.0517 76.0151 97.0971C76.0045 97.2722 75.9975 97.4472 75.9941 97.6223C75.9871 97.8183 75.9836 98.0144 75.9837 98.2105Z",
    fill: "url(#paint32_linear_18300_185650)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M118.206 92.0813C117.134 89.0241 114.454 86.8295 111.288 86.7914C107.107 86.7412 103.675 90.4624 103.675 95.1038C103.675 90.4624 100.202 86.6582 95.8621 86.606C92.4917 86.5655 89.581 88.7949 88.4005 91.9892C83.8765 103.518 103.675 113.633 103.675 113.633C103.675 113.633 122.243 102.919 118.206 92.0813Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M110.033 114.35C106.892 107.935 110.067 101.795 105.812 97.6279C101.426 93.3331 95.6296 97.3849 89.2644 93.8311C86.7676 92.437 83.9674 89.7513 81.8695 84.2031C78.1917 88.042 75.9861 92.908 75.9861 98.2094C75.9861 111.044 88.6941 120.888 103.676 120.227C106.871 120.094 110.026 119.465 113.027 118.364C111.791 117.222 110.776 115.861 110.033 114.35Z",
    fill: "url(#paint33_linear_18300_185650)"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8538 134.261C22.8362 134.818 22.8483 135.376 22.8902 135.932C22.9155 136.169 22.9197 136.402 22.9563 136.633C23.0296 137.098 23.1092 137.558 23.2248 138.009C23.2812 138.234 23.3364 138.459 23.4012 138.682C23.4464 138.828 23.4909 138.978 23.5388 139.124C24.6888 142.568 27.0294 145.552 30.1495 147.778C30.2172 147.825 30.2811 147.873 30.3487 147.918C31.4433 148.679 32.6056 149.337 33.8209 149.885C33.897 149.919 33.9729 149.953 34.0517 149.987C34.5958 150.226 35.1538 150.446 35.7258 150.646C35.9682 150.73 36.2163 150.812 36.4643 150.888C36.6306 150.942 36.7969 150.992 36.9659 151.04C37.2168 151.114 37.4704 151.181 37.727 151.246C37.8961 151.288 38.068 151.331 38.2399 151.37C40.4661 151.88 42.7512 152.085 45.0327 151.982C45.2074 151.973 45.3822 151.965 45.5541 151.953C45.6049 151.951 45.6556 151.945 45.7034 151.942C45.7176 151.942 45.7317 151.939 45.7458 151.939C45.8556 151.931 45.9656 151.925 46.0727 151.914C46.1291 151.908 46.1826 151.905 46.2362 151.9C46.3545 151.889 46.4758 151.877 46.5941 151.866C46.6449 151.86 46.6956 151.852 46.7464 151.846C46.8676 151.835 46.9916 151.821 47.1127 151.804C47.1579 151.798 47.2001 151.793 47.2453 151.787C47.3749 151.77 47.5045 151.753 47.6371 151.734C47.6681 151.728 47.7019 151.722 47.7356 151.717C47.8794 151.697 48.0204 151.674 48.1642 151.649C48.1839 151.646 48.2036 151.447 48.2205 151.444C48.3811 151.416 48.5418 151.16 48.6997 151.16H48.7024C50.0441 151.16 51.3351 150.74 52.561 150.286C52.5583 150.283 52.5583 150.381 52.5554 150.379C52.9387 150.238 53.3165 150.135 53.6885 149.974C54.0182 149.83 54.3425 149.706 54.6609 149.551C54.8159 149.675 54.9963 149.817 55.1964 149.955C57.6723 148.908 59.9288 147.404 61.8483 145.523C61.6301 145.23 61.4269 144.926 61.2394 144.613C63.8805 141.604 65.4307 137.906 65.4307 133.964C65.4307 124.51 56.5156 116.576 45.0327 116.23C44.6578 116.218 44.3848 116.216 44.0155 116.222C32.7638 116.365 23.3131 123.833 22.9669 133.458V133.895C22.9669 134.016 22.8538 134.137 22.8538 134.261Z",
    fill: "url(#paint34_linear_18300_185650)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2767 134.195C24.2767 144.291 34.0458 152.085 45.7457 151.938C46.0163 151.936 46.2896 151.927 46.5631 151.916C46.8111 151.905 47.0591 151.891 47.3043 151.871C47.5552 151.854 47.806 151.831 48.0541 151.806C48.1048 151.8 48.1555 151.798 48.2063 151.789C48.3669 151.772 48.5248 151.755 48.6854 151.733C48.8433 151.713 48.9984 151.693 49.1561 151.668C49.3816 151.637 49.6071 151.6 49.8298 151.561C49.9651 151.536 50.0976 151.513 50.23 151.488C51.5427 151.236 52.8324 150.875 54.0858 150.411C54.4635 150.27 54.8327 150.124 55.1963 149.966C57.6725 148.917 59.929 147.412 61.8482 145.528C65.0473 142.361 66.9609 138.281 66.9609 133.899C66.9609 124.446 58.0459 116.511 46.5631 116.165C45.6805 116.137 44.797 116.156 43.9164 116.221C34.5799 116.895 26.7972 122.618 24.7861 130.28L24.7852 130.283C24.7347 130.476 24.6873 130.669 24.644 130.865C24.63 130.927 24.6175 130.991 24.6043 131.054C24.5719 131.209 24.5393 131.364 24.5118 131.521C24.4708 131.751 24.434 131.982 24.4035 132.215C24.4064 132.217 24.4035 132.22 24.4035 132.226C24.3922 132.313 24.3809 132.403 24.3725 132.491C24.3583 132.601 24.3471 132.71 24.3387 132.82C24.3274 132.941 24.3161 133.065 24.3104 133.187C24.3077 133.223 24.3048 133.263 24.302 133.299C24.2935 133.44 24.2878 133.581 24.2851 133.722C24.2795 133.88 24.2767 134.038 24.2767 134.195Z",
    fill: "url(#paint35_linear_18300_185650)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2767 134.195C24.2767 144.291 34.0458 152.085 45.7457 151.938C46.0163 151.936 46.2896 151.927 46.5631 151.916C46.8111 151.905 47.0591 151.891 47.3043 151.871C47.5552 151.854 47.806 151.831 48.0541 151.806C48.1048 151.8 48.1555 151.798 48.2063 151.789C48.3669 151.772 48.5248 151.755 48.6854 151.733C48.8433 151.713 48.9984 151.693 49.1561 151.668C49.3816 151.637 49.6071 151.6 49.8298 151.561C49.9651 151.536 50.0976 151.513 50.23 151.488C51.5427 151.236 52.8324 150.875 54.0858 150.411C54.4635 150.27 54.8327 150.124 55.1963 149.966C57.6725 148.917 59.929 147.412 61.8482 145.528C65.0473 142.361 66.9609 138.281 66.9609 133.899C66.9609 124.446 58.0459 116.511 46.5631 116.165C45.6805 116.137 44.797 116.156 43.9164 116.221C34.5799 116.895 26.7972 122.618 24.7861 130.28L24.7852 130.283C24.7347 130.476 24.6873 130.669 24.644 130.865C24.63 130.927 24.6175 130.991 24.6043 131.054C24.5719 131.209 24.5393 131.364 24.5118 131.521C24.4708 131.751 24.434 131.982 24.4035 132.215C24.4064 132.217 24.4035 132.22 24.4035 132.226C24.3922 132.313 24.3809 132.403 24.3725 132.491C24.3583 132.601 24.3471 132.71 24.3387 132.82C24.3274 132.941 24.3161 133.065 24.3104 133.187C24.3077 133.223 24.3048 133.263 24.302 133.299C24.2935 133.44 24.2878 133.581 24.2851 133.722C24.2795 133.88 24.2767 134.038 24.2767 134.195Z",
    fill: "url(#paint36_linear_18300_185650)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1777 144.276C50.1364 136.003 49.8713 129.98 49.6132 129.256C49.5585 129.102 49.4594 128.903 49.333 128.562C47.9486 124.823 49.0082 122.39 47.8037 121.578C47.2693 121.218 46.5914 121.381 46.0272 121.516C43.3122 122.167 41.5368 125.98 42.1412 128.88C42.2119 129.218 42.3152 129.549 42.4495 129.868C42.2619 129.875 42.1163 129.879 41.9709 129.886C40.7545 129.943 39.5287 129.926 38.3237 130.076C37.1583 130.228 36.0896 130.804 35.321 131.693C34.5523 132.582 34.1374 133.722 34.1552 134.897C34.1714 136.197 34.1619 137.514 34.3583 138.793C34.6725 140.838 35.9743 142.253 37.6852 143.311C38.6496 143.919 39.7284 144.324 40.8552 144.501C41.3241 144.57 41.7982 144.597 42.2719 144.583C45.1248 144.518 49.5592 144.306 50.1777 144.276Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6257 129.533C51.8058 134.448 51.9839 139.311 52.1634 144.207C53.2105 144.169 54.2426 144.159 55.2697 144.081C55.7428 144.046 56.027 143.604 56.0132 143.065C55.9887 142.114 55.9496 141.162 55.9146 140.211C55.7968 137.007 55.6783 133.803 55.5591 130.599C55.5272 129.747 55.1662 129.407 54.3244 129.435C53.4325 129.465 52.5409 129.5 51.6257 129.533Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6819 147.186C49.1534 142.023 51.7095 137.081 48.2847 133.727C44.7546 130.27 40.089 133.531 34.9659 130.671C32.9563 129.549 30.7025 127.387 29.014 122.922C26.0539 126.012 24.2786 129.928 24.2786 134.195C24.2786 144.525 34.5069 152.448 46.5654 151.916C49.1367 151.809 51.6758 151.303 54.0918 150.417C53.0966 149.497 52.2796 148.402 51.6819 147.186Z",
    fill: "url(#paint37_linear_18300_185650)"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3331 217.454L70.6688 208.748C70.7148 208.577 70.803 208.42 70.9254 208.292C71.0478 208.164 71.2005 208.069 71.3693 208.015L75.4507 206.72C75.4553 206.718 75.4563 206.718 75.4663 206.715L75.4981 206.705C75.5098 206.702 75.5216 206.7 75.5335 206.698C75.542 206.697 75.5513 206.696 75.5606 206.694C75.5694 206.693 75.5779 206.69 75.5867 206.69C75.7572 206.66 75.9327 206.677 76.0943 206.739C76.2559 206.802 76.3975 206.906 76.5039 207.043C76.4192 207.113 76.3168 207.158 76.2081 207.173C76.0993 207.188 75.9885 207.173 75.8879 207.129L72.9689 216.521L68.7334 217.839C68.6792 217.856 68.6215 217.858 68.5663 217.845C68.5111 217.832 68.4605 217.804 68.4196 217.765C68.3787 217.726 68.3491 217.676 68.3339 217.621C68.3186 217.567 68.3184 217.509 68.3331 217.454Z",
    fill: "url(#paint38_linear_18300_185650)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0301 217.45L71.3299 209.02C71.3761 208.851 71.4635 208.696 71.5844 208.569C71.7053 208.443 71.8559 208.348 72.0225 208.294L76.2055 206.935C76.2509 206.92 76.2996 206.918 76.3461 206.929C76.3926 206.94 76.4352 206.963 76.4692 206.997C76.5033 207.031 76.5274 207.073 76.539 207.119C76.5507 207.166 76.5493 207.214 76.5352 207.26L73.7737 216.162C73.7395 216.272 73.6791 216.373 73.5976 216.454C73.5161 216.536 73.4159 216.596 73.3057 216.631L69.4302 217.836C69.3759 217.853 69.3181 217.855 69.2628 217.842C69.2075 217.829 69.1567 217.801 69.1158 217.762C69.0749 217.722 69.0454 217.673 69.0303 217.618C69.0152 217.563 69.0151 217.505 69.0301 217.45Z",
    fill: "url(#paint39_linear_18300_185650)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4631 214.248C82.1941 215.771 79.0275 227.19 70.039 230.594C62.9526 233.278 54.4947 230.302 50.4376 224.411C48.0984 221.014 45.9796 214.949 48.5775 212C48.6956 211.866 50.1634 210.25 52.2566 210.365C57.1028 210.631 57.4157 219.74 62.6126 220.854C63.834 221.116 64.2729 220.711 74.4761 216.263C79.3983 214.118 80.0496 213.883 80.4631 214.248Z",
    fill: "url(#paint40_linear_18300_185650)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M67.232 218.79C67.232 218.79 66.7983 217.1 67.8392 216.319C68.88 215.539 69.3137 213.501 69.4872 214.238C69.6606 214.975 69.4872 215.842 69.4872 215.842C69.4872 215.842 73.2168 212.591 73.1735 213.718C73.1301 214.845 70.4412 218.617 68.7065 219.354C66.9718 220.091 67.2589 220.204 67.232 218.79Z",
    fill: "url(#paint41_linear_18300_185650)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9962 214.367C79.9962 214.367 80.054 211.968 81.2972 211.419C82.5404 210.87 83.9572 208.095 83.8704 209.511C83.7837 210.928 82.5115 211.592 82.5115 211.592C82.5115 211.592 84.5643 212.331 83.668 213.479C82.7717 214.627 81.7598 214.859 80.719 215.379C80.719 215.379 80.4371 216.253 79.7215 216.123C79.0059 215.993 79.6203 214.757 79.9962 214.367Z",
    fill: "url(#paint42_linear_18300_185650)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3845 244.156C29.4639 247.47 22.8928 246.482 18.2955 245.79C13.1005 245.009 8.09716 244.256 6.13406 240.376C4.19112 236.535 5.92727 231.015 8.99559 228.013C12.6005 224.487 16.1969 226.243 18.7043 222.803C21.2733 219.279 18.24 216.419 20.5439 212.484C23.4436 207.532 29.6722 209.632 32.7054 204.617C35.1939 200.503 32.1443 197.142 34.6471 194.503C38.1183 190.844 48.2431 192.801 49.8646 197.111C50.4982 198.796 49.5375 200.054 48.8279 202.421C46.5704 209.953 51.188 214.228 51.6119 221.066C52.1844 230.304 44.9159 240.07 36.3845 244.156Z",
    fill: "url(#paint43_linear_18300_185650)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6935 322.758C31.6935 322.758 38.6201 323.635 38.8849 325.209C39.1924 327.036 31.1826 325.431 31.1826 325.431C31.1826 325.431 29.9562 325.028 31.6935 322.758Z",
    fill: "url(#paint44_linear_18300_185650)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1338 319.016L31.9649 322.881C31.9649 322.881 32.8115 323.954 33.7815 323.178L34.5547 319.016H32.1338Z",
    fill: "url(#paint45_linear_18300_185650)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9768 324.633C42.9768 324.633 49.9033 325.51 50.1681 327.084C50.4756 328.911 42.4658 327.306 42.4658 327.306C42.4658 327.306 41.2394 326.903 42.9768 324.633Z",
    fill: "url(#paint46_linear_18300_185650)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4189 320.887L43.25 324.752C43.25 324.752 44.0967 325.825 45.0666 325.049L45.8398 320.887H43.4189Z",
    fill: "url(#paint47_linear_18300_185650)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7607 257.168C52.2494 264.973 51.0179 272.714 49.0818 280.293C48.2119 283.704 47.3371 286.548 45.368 292.457C43.0167 299.514 39.7012 309.153 35.3798 320.796C34.1266 320.987 32.8734 321.179 31.6202 321.37C29.026 311.918 29.7715 304.485 32.4352 298.576C34.0128 295.076 34.9411 295.044 36.5649 291.136C38.2906 286.984 38.9957 282.8 38.5595 268.676C38.4359 264.676 38.2049 259.36 37.7385 253.07C42.7459 254.436 47.7533 255.802 52.7607 257.168Z",
    fill: "url(#paint48_linear_18300_185650)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M52.7607 257.168C52.2494 264.973 51.0179 272.714 49.0818 280.293C48.2119 283.704 47.3371 286.548 45.368 292.457C43.0167 299.514 39.7012 309.153 35.3798 320.796C34.1266 320.987 32.8734 321.179 31.6202 321.37C29.4042 312.547 31.027 307.915 33.0428 305.298C34.2883 303.682 35.8526 302.615 36.9945 299.834C38.3382 296.561 37.3866 295.079 38.0845 291.247C39.0252 286.082 41.2588 286.005 42.0476 281.965C42.9778 277.201 40.3398 274.907 38.5595 268.676C37.5689 265.208 36.6982 260.011 37.7385 253.07C42.7459 254.436 47.7533 255.802 52.7607 257.168Z",
    fill: "url(#paint49_linear_18300_185650)"
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0802 256.281C47.2317 260.25 56.0872 272.462 56.3439 290.238C56.5833 306.817 49.2035 318.626 46.2449 322.872C45.0124 322.76 43.7798 322.648 42.5473 322.535C42.0984 317.521 42.3046 312.47 43.1605 307.509C44.7729 298.206 47.3257 297.201 46.9418 291.897C46.4602 285.243 42.2525 284.175 35.7001 272.089C32.1692 265.576 27.9515 257.796 30.6924 254.915C31.2118 254.369 33.7555 252.135 44.0802 256.281Z",
    fill: "url(#paint50_linear_18300_185650)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2856 207.593C51.7249 208.401 54.3848 211.444 55.1179 212.307C56.0291 213.381 58.724 216.882 58.7756 225.84C58.825 234.429 56.3724 235.422 55.6289 243.57C54.5323 255.587 59.1559 261.227 55.9321 263.937C53.1881 266.242 49.851 262.146 40.605 262.589C32.9737 262.956 31.5042 265.926 24.9439 265.183C23.9413 265.069 15.1824 263.987 13.8301 259.406C12.8907 256.223 16.3475 254.135 21.0861 246.431C25.6225 239.055 27.8537 232.19 28.962 228.779C32.3055 218.491 30.9181 215.679 34.6971 211.917C35.1682 211.448 40.4547 206.35 47.2856 207.593Z",
    fill: "url(#paint51_linear_18300_185650)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8002 199.43C42.8002 199.43 43.7043 205.708 40.258 209.078C40.202 209.132 40.1617 209.199 40.1413 209.274C40.1209 209.348 40.1212 209.427 40.1422 209.501C40.1633 209.575 40.2042 209.643 40.2606 209.695C40.317 209.748 40.3868 209.784 40.4624 209.801C42.0631 210.137 45.7864 210.679 49.3973 209.466C49.4686 209.442 49.532 209.398 49.581 209.341C49.6299 209.283 49.6625 209.214 49.6754 209.139C49.6883 209.065 49.6811 208.989 49.6544 208.918C49.6278 208.847 49.5827 208.785 49.5238 208.738C48.7688 208.132 47.498 206.974 46.8208 205.583C45.8171 203.522 45.6382 200.006 45.6382 200.006L42.8002 199.43Z",
    fill: "url(#paint52_linear_18300_185650)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0842 246.429C25.6206 239.053 27.8517 232.188 28.9601 228.778C32.3036 218.49 30.9161 215.677 34.6952 211.915C35.913 210.755 37.2934 209.778 38.7929 209.016C38.1729 211.035 37.8015 213.411 38.1512 215.983C39.3435 224.753 47.8122 227.802 46.7358 233.249C45.7517 238.229 38.2126 238.022 37.1292 243.364C36.0141 248.862 43.3129 252.472 41.8303 256.339C40.3993 260.071 33.0621 258.11 25.7853 262.571C24.7123 263.23 23.7033 263.988 22.7715 264.835C19.7936 264.241 14.8201 262.764 13.8282 259.404C12.8888 256.221 16.3456 254.133 21.0842 246.429Z",
    fill: "url(#paint53_linear_18300_185650)"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6945 201.675C42.6945 201.675 44.251 203.811 46.692 202.921C48.8776 202.124 47.5731 196.48 45.8395 195.837C45.2612 195.622 44.1993 195.717 43.4895 196.16C42.9902 196.471 41.6572 198.127 42.4214 199.982C41.8692 199.822 41.3832 199.967 41.2615 200.241C41.1069 200.587 41.5746 201.059 41.6804 201.167C41.957 201.438 42.3116 201.616 42.6945 201.675Z",
    fill: "url(#paint54_linear_18300_185650)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7969 218.908C68.9745 218.598 68.1521 218.288 67.3297 217.978C66.8455 218.859 63.6156 224.525 57.5698 225.385C51.8691 226.197 46.5156 222.331 44.0287 218.54C41.67 214.946 42.1492 211.815 39.9408 211.133C37.7189 210.447 34.9646 212.915 33.6556 214.607C30.5597 218.609 30.6685 224.578 32.5826 228.859C35.6944 235.819 44.0546 239.382 51.1814 238.657C62.2222 237.533 67.3378 226.42 68.1999 224.414C68.9555 222.651 69.4918 220.802 69.7969 218.908Z",
    fill: "url(#paint55_linear_18300_185650)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9658 210.961C96.9658 210.961 64.6529 237.824 86.0393 243.871C86.0393 243.871 96.0845 247.111 102.241 243.871C102.025 237.501 100.189 235.449 100.189 235.449C100.189 235.449 93.8162 234.532 96.0845 231.157C98.3528 227.782 101.593 223.031 101.593 223.031L96.9658 210.961Z",
    fill: "url(#paint56_linear_18300_185650)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M157.445 181.94C157.445 181.94 158.765 175.047 160.085 172.994C161.406 170.941 163.869 169.621 163.869 169.621C163.869 169.621 164.382 170.465 162.747 172.243C161.112 174.021 162.475 174.197 162.747 174.768C163.019 175.341 162.433 177.394 161.259 178.127C160.085 178.86 159.645 182.858 159.645 182.858L157.445 181.94Z",
    fill: "url(#paint57_linear_18300_185650)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M161.259 181.061C159.841 180.817 158.423 180.573 157.005 180.328C151.929 189.735 145.983 195.781 141.934 199.291C137.15 203.438 134.061 206.116 128.986 207.459C121.488 209.442 115.011 207.113 114.169 209.218C113.758 210.247 115.185 211.362 117.47 214.094C124.124 222.053 123.495 226.332 127.152 227.513C130.174 228.489 133.215 226.39 138.374 222.71C143.067 219.363 148.952 215.166 153.924 207.165C160.593 196.433 161.262 185.875 161.259 181.061Z",
    fill: "url(#paint58_linear_18300_185650)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6696 332.334C94.547 331.658 92.3653 331.047 91.285 331.952C90.7486 332.401 90.3792 333.312 90.6896 333.723C90.8025 333.873 90.3401 334.136 90.7832 334.141C92.2528 334.158 94.7916 333.005 94.6696 332.334Z",
    fill: "url(#paint59_linear_18300_185650)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3836 332.58L90.1398 332.263C91.1792 331.012 90.9869 327.027 90.9869 327.027L93.373 327.56C93.373 327.56 93.1012 328.653 92.6386 330.267C92.4803 330.819 92.4096 331.683 92.3836 332.58Z",
    fill: "url(#paint60_linear_18300_185650)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5824 332.304C92.5824 332.304 89.881 331.682 89.5888 332.218C89.2966 332.753 89.0698 334.188 90.7837 334.142C92.4976 334.096 92.7346 332.759 92.5824 332.304Z",
    fill: "url(#paint61_linear_18300_185650)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M125.457 334.865C125.241 334.213 122.995 333.913 122.052 334.96C121.584 335.48 121.346 336.434 121.711 336.798C121.843 336.93 121.422 337.255 121.862 337.199C123.319 337.01 125.672 335.513 125.457 334.865Z",
    fill: "url(#paint62_linear_18300_185650)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M123.227 335.431H120.961C121.815 334.047 121.067 330.129 121.067 330.129L123.504 330.322C123.504 330.322 123.388 331.443 123.156 333.105C123.076 333.674 123.127 334.54 123.227 335.431Z",
    fill: "url(#paint63_linear_18300_185650)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M129.101 249.765C130.691 255.023 131.866 260.398 132.614 265.841C135.367 285.856 129.517 286.495 130.609 308.675C130.958 315.755 124.474 332.08 123.902 332.441C123.604 332.472 123.305 332.483 123.005 332.476C122.231 332.449 121.463 332.321 120.721 332.095C119.694 331.919 115.991 321.891 116.849 315.929C117.457 311.709 117.281 307.181 116.929 298.124C116.871 296.656 113.116 269.571 113.116 269.571C111.973 279.597 110.659 288.115 109.52 294.719C105.86 315.938 93.9608 328.781 93.3402 328.987C93.2175 329.036 92.101 329.441 91.1881 328.84C90.9525 328.691 90.7638 328.478 90.6435 328.227C90.3252 327.977 90.7373 307.042 94.3668 291.287C99.635 268.418 97.341 263.067 99.0101 252.852C100.454 244.014 129.101 249.765 129.101 249.765Z",
    fill: "url(#paint64_linear_18300_185650)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1766 228.17C97.2698 232.428 97.2914 232.022 98.6221 237.387C99.5554 241.145 101.53 245.226 99.0107 252.854C102.283 254.587 105.826 255.754 109.488 256.305C119.201 257.747 127.349 254.841 130.512 253.217C130.98 251.093 131.287 248.938 131.432 246.768C131.639 243.762 131.648 239.806 131.233 234.329C130.933 230.488 130.238 226.689 129.159 222.991C128.308 220.102 127.466 218.158 126.528 216.495C125.632 214.905 124.586 213.404 123.405 212.012C122.955 211.485 123.862 211.001 123.789 210.932C119.36 206.95 111.32 208.185 107.82 208.289C105.271 208.362 100.791 208.47 97.4078 210.656C96.6217 211.158 95.9154 211.775 95.3125 212.487C94.0725 213.955 94.3662 221.138 96.1766 228.17Z",
    fill: "url(#paint65_linear_18300_185650)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M123.387 335.127C123.387 335.127 120.625 334.889 120.41 335.461C120.196 336.032 120.172 337.484 121.863 337.199C123.553 336.913 123.601 335.556 123.387 335.127Z",
    fill: "url(#paint66_linear_18300_185650)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M106.92 205.073C105.208 203.81 104.836 201.695 104.76 201.237C104.441 199.316 104.485 198.986 104.652 198.48L104.905 197.803C104.905 197.803 104.924 197.77 104.945 197.736C105.171 197.383 106.208 196.524 106.459 196.403C107.261 196.015 110.172 198.245 113.044 202.366C113.19 202.495 113.336 202.626 113.482 202.758C114.077 203.299 117.782 207.565 118.484 207.767C123.683 209.255 125.576 209.01 124.406 210.069C123.024 211.318 106.608 210.347 106.447 209.312C106.375 208.853 107.98 208.47 109.443 208.029C110.954 207.574 111.164 206.097 110.754 205.415C110.364 205.487 108.181 206.004 106.92 205.073Z",
    fill: "url(#paint67_linear_18300_185650)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M102.605 197.787C103.563 199.01 105.161 199.87 105.619 199.852C105.899 199.853 106.176 199.901 106.441 199.991C106.506 200.013 106.567 200.044 106.624 200.082C107.494 200.646 106.973 202.511 107.479 202.673C107.847 202.79 108.421 201.804 108.689 201.944C108.941 202.075 108.576 203.037 108.872 203.199C109.096 203.321 109.392 202.82 109.881 202.893C110.125 202.929 110.173 203.071 110.65 203.391C110.9 203.562 111.165 203.709 111.442 203.831C112.427 204.221 113.832 203.55 113.839 203.082C113.841 202.952 113.733 202.927 113.589 202.607C113.495 202.376 113.432 202.133 113.404 201.885C113.331 201.28 113.701 200.518 113.967 199.612C114.46 197.934 114.229 197.01 114.14 196.706C114.108 196.598 114.08 196.52 114.059 196.464C113.647 195.333 112.615 194.005 111.573 193.504C109.827 192.666 108.796 194.51 106.484 194.133C103.816 193.698 103.017 190.889 102.046 191.265C100.976 191.68 100.832 195.525 102.605 197.787Z",
    fill: "#26264F"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M107.697 202.041C107.676 201.393 108.506 201.371 108.925 201.903C109.344 202.435 109.259 203.393 108.674 203.679C108.089 203.964 107.725 202.911 107.697 202.041Z",
    fill: "url(#paint68_linear_18300_185650)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M96.1756 228.17C97.2688 232.429 97.2903 232.023 98.6211 237.388C99.5544 241.145 101.529 245.227 99.0096 252.855C102.282 254.587 105.825 255.754 109.487 256.306C119.2 257.748 127.348 254.841 130.51 253.217C130.979 251.094 131.286 248.938 131.431 246.769C124.682 243.62 113.047 245.503 113.064 243.007C113.086 239.443 116.067 234.584 106.562 231.155C97.057 227.73 97.4067 210.656 97.4067 210.656C96.6207 211.158 95.9144 211.776 95.3115 212.487C94.0714 213.956 94.3651 221.139 96.1756 228.17Z",
    fill: "url(#paint69_linear_18300_185650)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18300_185650",
    x1: 324.716,
    y1: 137.215,
    x2: 203.435,
    y2: 137.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18300_185650",
    x1: 301.53,
    y1: 178.46,
    x2: 151.567,
    y2: 181.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18300_185650",
    x1: 238.024,
    y1: 214.956,
    x2: 216.746,
    y2: 159.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49405,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18300_185650",
    x1: 221.792,
    y1: 181.588,
    x2: 301.259,
    y2: 600.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18300_185650",
    x1: 226.536,
    y1: 57.1098,
    x2: 358.452,
    y2: 393.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18300_185650",
    x1: 221.123,
    y1: 198.281,
    x2: 175.24,
    y2: 198.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18300_185650",
    x1: 178.923,
    y1: 190.438,
    x2: 186.557,
    y2: 200.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_18300_185650",
    x1: 219.032,
    y1: 201.64,
    x2: 175.285,
    y2: 201.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_18300_185650",
    x1: 222.444,
    y1: 183.742,
    x2: 217.55,
    y2: 229.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_18300_185650",
    x1: 267.609,
    y1: 223.412,
    x2: 256.779,
    y2: 223.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_18300_185650",
    x1: 114.017,
    y1: 155.648,
    x2: 163.838,
    y2: 184.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05207,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14245,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31827,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48489,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77539,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86581,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_18300_185650",
    x1: 113.606,
    y1: 158.887,
    x2: 160.537,
    y2: 186.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05207,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14245,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31827,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48489,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77539,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86581,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_18300_185650",
    x1: 135.245,
    y1: 163.504,
    x2: 131.014,
    y2: 202.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_18300_185650",
    x1: 166.134,
    y1: 118.249,
    x2: 132.158,
    y2: 118.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_18300_185650",
    x1: 292.404,
    y1: 105.923,
    x2: 141.706,
    y2: 105.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05207,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14245,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31827,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48489,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77539,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86581,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_18300_185650",
    x1: 163.375,
    y1: 129.668,
    x2: 261.796,
    y2: 240.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05207,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14245,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31827,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48489,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77539,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86581,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_18300_185650",
    x1: 247.816,
    y1: 118.796,
    x2: 158.792,
    y2: 118.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_18300_185650",
    x1: 300.849,
    y1: 118.085,
    x2: 266.872,
    y2: 118.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_18300_185650",
    x1: 304.729,
    y1: 118.085,
    x2: 289.872,
    y2: 118.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_18300_185650",
    x1: 279.122,
    y1: 196.616,
    x2: 195.928,
    y2: 196.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05207,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14245,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31827,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48489,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77539,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86581,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_18300_185650",
    x1: 234.744,
    y1: 305.217,
    x2: 222.716,
    y2: 212.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05207,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14245,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31827,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39746,
    stopColor: "#FEC045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70952,
    stopColor: "#FAA34B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86581,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_18300_185650",
    x1: 298.525,
    y1: 180.972,
    x2: 263.232,
    y2: 188.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05207,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14245,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31827,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48489,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77539,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86581,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_18300_185650",
    x1: 267.173,
    y1: 207.516,
    x2: 253.373,
    y2: 221.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_18300_185650",
    x1: 288.954,
    y1: 188.894,
    x2: 279.358,
    y2: 223.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05207,
    stopColor: "#FDBA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14245,
    stopColor: "#FFC244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31827,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48489,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77539,
    stopColor: "#F99C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86581,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_18300_185650",
    x1: 298.58,
    y1: 181.326,
    x2: 294.348,
    y2: 220.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_18300_185650",
    x1: 102.858,
    y1: 130.332,
    x2: 118.297,
    y2: 139.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_18300_185650",
    x1: 119.408,
    y1: 137.997,
    x2: 85.473,
    y2: 137.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_18300_185650",
    x1: 90.1511,
    y1: -20.3887,
    x2: 51.606,
    y2: 56.9859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_18300_185650",
    x1: 67.4721,
    y1: 30.4284,
    x2: 30.0324,
    y2: 99.8893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_18300_185650",
    x1: 77.7598,
    y1: 35.0423,
    x2: 41.3887,
    y2: 108.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_18300_185650",
    x1: 62.4712,
    y1: 2.852,
    x2: 141.853,
    y2: 201.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_18300_185650",
    x1: 112.363,
    y1: 79.7039,
    x2: 75.8362,
    y2: 147.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_18300_185650",
    x1: 112.363,
    y1: 79.7039,
    x2: 75.8362,
    y2: 147.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_18300_185650",
    x1: 82.8566,
    y1: 83.5733,
    x2: 118.659,
    y2: 155.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_18300_185650",
    x1: 13.4011,
    y1: 57.4452,
    x2: 77.2925,
    y2: 217.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_18300_185650",
    x1: 53.5568,
    y1: 119.3,
    x2: 24.158,
    y2: 173.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_18300_185650",
    x1: 53.5568,
    y1: 119.3,
    x2: 24.158,
    y2: 173.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_18300_185650",
    x1: 29.8085,
    y1: 122.415,
    x2: 58.6248,
    y2: 180.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_18300_185650",
    x1: 69.3681,
    y1: 204.099,
    x2: 70.524,
    y2: 207.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_18300_185650",
    x1: 76.5468,
    y1: 212.386,
    x2: 69.0189,
    y2: 212.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_18300_185650",
    x1: 80.917,
    y1: 220.974,
    x2: 47.3848,
    y2: 220.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_18300_185650",
    x1: 56.7615,
    y1: 318.943,
    x2: 51.9219,
    y2: 356.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_18300_185650",
    x1: 67.8688,
    y1: 320.383,
    x2: 63.0291,
    y2: 357.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_18300_185650",
    x1: 42.3408,
    y1: 214.271,
    x2: 15.878,
    y2: 235.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_18300_185650",
    x1: 42.3157,
    y1: 315.825,
    x2: 30.3287,
    y2: 329.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_18300_185650",
    x1: 34.5547,
    y1: 321.238,
    x2: 31.9649,
    y2: 321.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_18300_185650",
    x1: 49.8138,
    y1: 322.172,
    x2: 37.8269,
    y2: 336.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_18300_185650",
    x1: 45.8398,
    y1: 323.109,
    x2: 43.25,
    y2: 323.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_18300_185650",
    x1: 52.7607,
    y1: 287.22,
    x2: 30.0131,
    y2: 287.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_18300_185650",
    x1: 52.7607,
    y1: 287.22,
    x2: 30.5557,
    y2: 287.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_18300_185650",
    x1: 56.3496,
    y1: 288.348,
    x2: 29.812,
    y2: 288.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_18300_185650",
    x1: 58.7764,
    y1: 236.35,
    x2: 13.6755,
    y2: 236.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_18300_185650",
    x1: 52.4505,
    y1: 209.986,
    x2: 40.9037,
    y2: 203.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_18300_185650",
    x1: 58.7744,
    y1: 236.925,
    x2: 13.6737,
    y2: 236.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_18300_185650",
    x1: 43.885,
    y1: 194.454,
    x2: 46.8548,
    y2: 221.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_18300_185650",
    x1: 51.6601,
    y1: 225.171,
    x2: 69.8054,
    y2: 273.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_18300_185650",
    x1: 112.309,
    y1: 188.694,
    x2: 90.9291,
    y2: 237.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_18300_185650",
    x1: 166.897,
    y1: 161.773,
    x2: 154.359,
    y2: 190.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_18300_185650",
    x1: 145.578,
    y1: 182.297,
    x2: 118.24,
    y2: 245.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_18300_185650",
    x1: 95.9083,
    y1: 330.369,
    x2: 91.1047,
    y2: 333.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_18300_185650",
    x1: 91.2557,
    y1: 333.59,
    x2: 92.3061,
    y2: 326.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_18300_185650",
    x1: 95.5479,
    y1: 329.827,
    x2: 90.7444,
    y2: 333.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_18300_185650",
    x1: 126.384,
    y1: 332.765,
    x2: 122.074,
    y2: 336.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_18300_185650",
    x1: 122.232,
    y1: 336.608,
    x2: 122.232,
    y2: 329.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_18300_185650",
    x1: 122.587,
    y1: 340.05,
    x2: 94.5016,
    y2: 226.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_18300_185650",
    x1: 137.71,
    y1: 175.716,
    x2: 107.595,
    y2: 245.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_18300_185650",
    x1: 125.951,
    y1: 332.278,
    x2: 121.642,
    y2: 336.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_18300_185650",
    x1: 58.2632,
    y1: 340.816,
    x2: 43.3415,
    y2: 377.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_18300_185650",
    x1: 52.3589,
    y1: 338.422,
    x2: 37.4294,
    y2: 374.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_18300_185650",
    x1: 130.165,
    y1: 193.073,
    x2: 106.657,
    y2: 247.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarImageStart);
export default __webpack_public_path__ + "static/media/calendarImageStart.05a7c336b045e0e26664444715f6052d.svg";
export { ForwardRef as ReactComponent };